import { priceListDefaultService } from '../services'
import Vue from 'vue'

const state = {
  all: {
    filterInitialized: false,
    loading: true,
    saving: false,
    items: {},
    filter: {},
    defaultFilter: {
      year: null,
      orderByColumn: 'year',
      orderByDescending: false
    },
    currentPage: 1,
    meta: {}
  }
}

const actions = {
  initialize ({ commit }) {
    commit('initialize')
  },

  getLatest ({ commit }) {
    console.log('module start')
    return priceListDefaultService.getLatest().then(data => {
      console.log('module end')
      return data.result
    })
  },

  resetFilter ({ commit }) {
    commit('resetFilter')
  },

  getListData ({ commit }) {
    commit('getListDataRequest')

    priceListDefaultService.getListData(state.all.filter, state.all.currentPage)
      .then(
        data => {
          commit('getListDataSuccess', data.result)
        }
      )
  },

  getById ({commit}, id) {
    return priceListDefaultService.getById(id)
      .then(priceList => {
        return priceList.result
      })
  },

  create ({ commit, dispatch }, priceList) {
    commit('startSave')
    return priceListDefaultService.create(priceList)
      .then(priceList => {
        commit('endSave')
        commit('createSuccess', priceList.result)
        dispatch('getListData')
        return priceList.result
      }).catch(error => {
        commit('endSave')
        commit('createFailure')
        return Promise.reject(error)
      })
  },

  update ({ commit }, priceList) {
    commit('startSave')
    return priceListDefaultService.update(priceList)
      .then(priceList => {
        commit('endSave')
        commit('updateSuccess', priceList.result)
        return priceList
      }).catch(error => {
        commit('endSave')
        commit('updateFailure')
        return Promise.reject(error)
      })
  },

  delete ({ commit }, id) {
    commit('startSave')
    commit('deleteRequest', id)

    priceListDefaultService.delete(id)
      .then(() => {
        commit('endSave')
        commit('deleteSuccess', id)
      })
  }
}

const getters = {
  isFilterChanged: state => (route) => {
    // Page should not be considered when comparing
    const currentFilter = Object.assign({}, state.all.filter)
    const defaultFilter = Object.assign({}, state.all.defaultFilter)

    currentFilter.page = null
    defaultFilter.page = null

    return !Vue.lodash.isEqual(currentFilter, defaultFilter)
  }
}

const mutations = {
  resetFilter (state) {
    state.all.currentPage = 1
    state.all.filter = Object.assign({}, state.all.defaultFilter)
  },

  initialize (state) {
    if (!state.all.filterInitialized) {
      mutations.resetFilter(state)
      state.all.filterInitialized = true
    }
  },

  startSave (state) {
    state.all.saving = true
  },

  endSave (state) {
    setTimeout(() => {
      state.all.saving = false
    }, 200)
  },

  // Get all
  getListDataRequest (state) {
    state.all.loading = true
  },

  getListDataSuccess (state, data) {
    state.all.items = data.items
    state.all.meta = data.meta
    state.all.loading = false
  },

  getListDataFailure (state, error) {
    state.all.error = error
    state.all.loading = false
  },

  // Create
  createSuccess (state, updatedPriceList) {
    Vue.prototype.$toast('Prislista skapad', 'success')
  },

  createFailure (state, error) {
    Vue.prototype.$toast('Kunde inte skapa prislista', 'error')
  },

  // Update
  updateSuccess (state, updatedPriceList) {
    state.all.items = state.all.items.map(priceList =>
      priceList.priceListDefaultId === updatedPriceList.priceListDefaultId ? updatedPriceList : priceList
    )

    Vue.prototype.$toast('Prislista uppdaterad', 'success')
  },

  updateFailure (state) {
    Vue.prototype.$toast('Kunde inte uppdatera prislista', 'error')
  },

  // Delete
  deleteRequest (state, id) {
    // add 'deleting:true' property to customer being deleted
    state.all.items = state.all.items.map(priceList =>
      priceList.priceListDefaultId === id
        ? { ...priceList, deleting: true }
        : priceList
    )
  },

  deleteSuccess (state, id) {
    // remove deleted customer from state
    state.all.items = state.all.items.filter(priceList => priceList.priceListDefaultId !== id)
  }
}

export const priceListDefault = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/price-list-default.module.js